import Vue from 'vue'

import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.prototype.$video = Video